import { Component} from '@angular/core';

@Component({
  selector: 'app-pycnometer-vertical-header',
  standalone: false,
  templateUrl: './pycnometer-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class PycnometerVerticalHeaderComponent {
}
